import React from "react";
import styled from "styled-components";
import VTuberStreamItem from "./VTuberStreamItem";
import InfiniteScroll from "./InfiniteScroll";
import Wrapper from "../atoms/Wrapper";
import CircularProgress from "@material-ui/core/CircularProgress";

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  ${(props) => (props.left ? "" : "justify-content: center;")}
`;

const Message = styled(Wrapper)`
  padding-top: 1rem;
  padding-left: 0.6rem;
  color: ${(props) => props.theme.colors.gray};
`;
const CircularProgressWrapper = styled(Wrapper)`
  width: 3.5rem;
  max-width: 100%;
`;

const Stream = (props) => {
  return (
    <StyledWrapper left={props.left}>
      {props.requestState === "failure" ? (
        <Message key={"failed_loading_vtuber_stream"}>
          読み込みに失敗しました
        </Message>
      ) : (
        <InfiniteScroll
          pageStart={0}
          loadMore={props.loadMore}
          hasMore={props.hasMore}
          initialLoad={
            props.initialLoad === undefined ? true : props.initialLoad
          }
          loader={
            <CircularProgressWrapper key="vtuber_stream_loading">
              <CircularProgress />
            </CircularProgressWrapper>
          }
          requestState={props.requestState}
          page={props.page}
          style={{ ...props.style, justifyContent: "center" }}
        >
          {props.items &&
            props.items.map((item, idx) => (
              <VTuberStreamItem
                item={item}
                key={item.id.toString()}
                rank={props.ranking && props.ranks && props.ranks[idx]}
                ranking={props.ranking}
              />
            ))}
        </InfiniteScroll>
      )}
    </StyledWrapper>
  );
};

export default Stream;
